import { faChevronRight } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { styled } from "@mui/material/styles"
import LinkPaperBox from "components/LinkPaperBox"

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: grey[500]
}))

const StyledGrid = styled(Grid)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  justifyContent: "space-between",
  padding: "3rem 2rem"
}))

export const ExaminationPdfLinkCard = (props) => {
  const { title, pdf, icon } = props

  return (
    <LinkPaperBox p={0} {...props}>
      <a href={pdf} target="__blank">
        <Grid container direction="row" justifyContent="space-between">
          <StyledGrid item xs={12}>
            <Typography variant="paragraphLarge">{title}</Typography>
            <Grid item md={1}>
              <StyledFontAwesomeIcon icon={icon ? icon : faChevronRight} size="2x" />
            </Grid>
          </StyledGrid>
        </Grid>
      </a>
    </LinkPaperBox>
  )
}
